var _defs, _path, _line, _line2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack182({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.4,4.93H13a2,2,0,0,1,2,2V9.07a2,2,0,0,1-2,2H4.4a0,0,0,0,1,0,0V4.93A0,0,0,0,1,4.4,4.93Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.4,
    y1: 6.98,
    x2: 14.98,
    y2: 6.98
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.4,
    y1: 9.02,
    x2: 14.98,
    y2: 9.02
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 2.01,
    y: 6.81,
    width: 2.38,
    height: 2.38,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 4.43,
    width: 1.01,
    height: 7.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack182);
export default __webpack_public_path__ + "static/media/Symbolpack_1_82.db770c91dec68860ca8c69d64abb9502.svg";
export { ForwardRef as ReactComponent };